import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: 'linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)',
        backgroundSize: '50px 50px'
      }}></div>

      {/* Gradient Orbs */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-teal-500/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center mb-4">
              <div className="text-4xl font-black">
                <span className="bg-gradient-to-r from-teal-400 to-cyan-400 bg-clip-text text-transparent">NEXT</span>
                <span className="text-white">AGE</span>
              </div>
              <div className="ml-3 text-xs font-bold tracking-wider text-gray-400">
                会社売買
              </div>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed mb-6">
              中小企業のM&A・事業承継を専門とする次世代型仲介プラットフォーム
            </p>
            <div className="flex space-x-3">
              {['ri-twitter-x-line', 'ri-facebook-circle-line', 'ri-linkedin-box-line'].map((icon, index) => (
                <a
                  key={index}
                  href="#"
                  className="w-10 h-10 bg-white/10 backdrop-blur-md rounded-xl flex items-center justify-center hover:bg-gradient-to-br hover:from-teal-500 hover:to-cyan-500 transition-all duration-300 cursor-pointer group"
                >
                  <i className={`${icon} text-lg text-gray-400 group-hover:text-white transition-colors`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-black mb-6 text-base flex items-center">
              <div className="w-1 h-6 bg-gradient-to-b from-teal-500 to-cyan-500 rounded-full mr-3"></div>
              サービス
            </h4>
            <ul className="space-y-3">
              {[
                { name: '売り会社の一覧表', path: '/company-list' },
                { name: '会社を売る', path: '/sell' },
                { name: '会社を買う', path: '/buy' },
                { name: '稼働法人の譲渡', path: '/active-company-transfer' }
              ].map((item) => (
                <li key={item.path}>
                  <Link 
                    to={item.path} 
                    className="text-sm text-gray-400 hover:text-teal-400 transition-colors flex items-center group cursor-pointer"
                  >
                    <i className="ri-arrow-right-s-line text-lg opacity-0 group-hover:opacity-100 -ml-5 group-hover:ml-0 transition-all"></i>
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-black mb-6 text-base flex items-center">
              <div className="w-1 h-6 bg-gradient-to-b from-teal-500 to-cyan-500 rounded-full mr-3"></div>
              企業情報
            </h4>
            <ul className="space-y-3">
              {[
                { name: '会社概要', path: '/about' },
                { name: '成約事例', path: '/cases' },
                { name: 'お問い合わせ', path: '/contact' },
                { name: 'プライバシーポリシー', path: '/privacy' }
              ].map((item) => (
                <li key={item.path}>
                  <Link 
                    to={item.path} 
                    className="text-sm text-gray-400 hover:text-teal-400 transition-colors flex items-center group cursor-pointer"
                  >
                    <i className="ri-arrow-right-s-line text-lg opacity-0 group-hover:opacity-100 -ml-5 group-hover:ml-0 transition-all"></i>
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-black mb-6 text-base flex items-center">
              <div className="w-1 h-6 bg-gradient-to-b from-teal-500 to-cyan-500 rounded-full mr-3"></div>
              お問い合わせ
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start group">
                <div className="w-10 h-10 bg-gradient-to-br from-cyan-500 to-teal-500 rounded-xl flex items-center justify-center mr-3 flex-shrink-0 group-hover:scale-110 transition-transform">
                  <i className="ri-mail-line text-lg text-white"></i>
                </div>
                <div>
                  <p className="text-xs text-gray-500 mb-1">メール</p>
                  <p className="text-base font-bold text-white">info@nextage.jp</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-gray-400 mb-4 md:mb-0">
            &copy; 2025 NEXTAGE. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-sm text-gray-400 hover:text-teal-400 transition-colors flex items-center group cursor-pointer"
          >
            <span>Powered by Readdy</span>
            <i className="ri-arrow-right-up-line ml-2 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"></i>
          </a>
        </div>
      </div>
    </footer>
  );
}
